import type OwaUserConfiguration from "owa-service/lib/contract/OwaUserConfiguration";
import type { UserConfigurationArgs } from "owa-graph-schema";
import { type default as WebKeyboardShortcutsMode } from "owa-service/lib/contract/KeyboardShortcutsMode";
import { type default as WebReactListViewType } from "owa-service/lib/contract/ReactListViewType";
import { type default as MailSwipeAction } from "owa-service/lib/contract/MailSwipeAction";
import { type default as MailTriageAction } from "owa-service/lib/contract/MailTriageAction";

export function createUserConfigurationUpdateFunction(updates: UserConfigurationArgs) {
    return (userConfig: OwaUserConfiguration): void => {
        internalUserConfigurationUpdateFunction(userConfig, updates);
    };
}

function internalUserConfigurationUpdateFunction(userConfig: OwaUserConfiguration, updates: UserConfigurationArgs) {
    /* eslint-disable-next-line owa-custom-rules/forbid-foreach-with-variables-outside-of-function-scope -- (https://aka.ms/OWALintWiki)
     * https://dev.azure.com/outlookweb/Outlook%20Web/_wiki/wikis/Outlook%20Web.wiki/9650/Use-for-const-loop-of-instead-of-forEach
     *	> When using a forEach function call, avoid using variables outside of the scope of the function, use for (const item of array) instead */
    Object.keys(updates).forEach(key => {
        const configKey = key as keyof UserConfigurationArgs;
        const internalUserConfig = userConfig[configKey];
        const internalUpdate = updates[configKey];
        if (internalUserConfig && internalUpdate) {
            Object.keys(internalUpdate).forEach(subKey => {
                const configSubKey = subKey as never;
                const value = applyUpdateConversionIfNecessary(configSubKey, internalUpdate[configSubKey]);
                if (value !== undefined && value !== null) {
                    internalUserConfig[configSubKey] = value as never;
                }
            });
        }
    });
}

function applyUpdateConversionIfNecessary(configKey: string, value: any) {
    if (configKey === "KeyboardShortcutsMode" && typeof value === "string") {
        switch (value) {
            case "Gmail":
                return 3;
            case "Hotmail":
                return 0;
            case "Off":
                return 1;
            case "Owa":
                return 4;
            case "Yahoo":
                return 2;
        }
    }
    
    if (configKey == "GlobalListViewTypeReact" && typeof value === "string") {
        switch (value) {
            case "Conversation":
                return 0;
            case "Message":
                return 1;
            case "CalendarItems":
                return 2;
        }
    }
    
    if ((configKey == "MailRightSwipeAction" || configKey == "MailLeftSwipeAction") &&
        typeof value === "string") {
        switch (value) {
            case "None":
                return 0;
            case "Delete":
                return 1;
            case "Archive":
                return 2;
            case "TogglePin":
                return 3;
            case "ToggleRead":
                return 4;
            case "ToggleFlag":
                return 5;
        }
    }
    
    if (configKey == "MailTriageOnHoverActions" && Array.isArray(value)) {
        const actionKeys: MailTriageAction[] = [];
        value.forEach((action: string) => {
            switch (action) {
                case "Archive":
                    actionKeys.push(2);
                    break;
                case "Delete":
                    actionKeys.push(1);
                    break;
                case "None":
                    actionKeys.push(0);
                    break;
                case "FlagUnflag":
                    actionKeys.push(5);
                    break;
                case "Move":
                    actionKeys.push(6);
                    break;
                case "PinUnpin":
                    actionKeys.push(3);
                    break;
                case "ReadUnread":
                    actionKeys.push(4);
                    break;
            }
        });
        return actionKeys;
    }
    
    return value;
}
